import React, { useState, useEffect } from 'react';
import { auth, userManagement } from '../../lib/supabase';

const SupabaseAuth = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);

  // Demo account credentials for easy testing
  const adminAccount = { username: 'admin', email: 'admin@myclass.edu.hk', password: 'Admin', role: 'admin' };
  
  const demoAccounts = [
    adminAccount, // Admin first for easy access
    { username: 'staff', email: 'staff@myclass.edu.hk', password: 'Staff123', role: 'staff' },
    { username: 'teacher', email: 'teacher@myclass.edu.hk', password: 'Teacher123', role: 'teacher' },
    { username: 'developer', email: 'developer@myclass.edu.hk', password: 'Developer123', role: 'developer' },
    { username: 'studentA', email: 'studenta@myclass.edu.hk', password: 'Student123', role: 'student' },
    { username: 'studentB', email: 'studentb@myclass.edu.hk', password: 'Student123', role: 'student' },
    { username: 'studentC', email: 'studentc@myclass.edu.hk', password: 'Student123', role: 'student' },
    { username: 'parent', email: 'parent@myclass.edu.hk', password: 'Parent123', role: 'parent' }
  ];

  const handleDemoLogin = async (demoAccount) => {
    setLoading(true);
    setError('');
    
    try {
      // For demo purposes, create a mock session without database lookup
      const mockSession = {
        user: {
          id: `demo_${demoAccount.username}`,
          email: demoAccount.email,
          username: demoAccount.username,
          role: demoAccount.role,
          // Ensure admin role is properly set in user metadata
          user_metadata: {
            role: demoAccount.role,
            ...(demoAccount.role === 'admin' && { is_admin: true, is_developer: true })
          },
          app_metadata: {
            role: demoAccount.role,
            ...(demoAccount.role === 'admin' && { is_admin: true, is_developer: true })
          },
          profile: {
            name: demoAccount.username === 'admin' ? '系統管理員' : 
                  demoAccount.username === 'staff' ? '學校職員' :
                  demoAccount.username === 'teacher' ? '張老師' :
                  demoAccount.username === 'parent' ? '陳先生' :
                  demoAccount.username === 'developer' ? '開發者' :
                  demoAccount.username === 'studentA' ? '陳小明' :
                  demoAccount.username === 'studentB' ? '李美玲' :
                  demoAccount.username === 'studentC' ? '王志強' : 'Demo User',
            english_name: demoAccount.username === 'admin' ? 'System Administrator' :
                         demoAccount.username === 'staff' ? 'School Staff' :
                         demoAccount.username === 'teacher' ? 'Mr. Cheung' :
                         demoAccount.username === 'parent' ? 'Mr. Chan' :
                         demoAccount.username === 'developer' ? 'Developer' :
                         demoAccount.username === 'studentA' ? 'Chan Siu Ming' :
                         demoAccount.username === 'studentB' ? 'Lee Mei Ling' :
                         demoAccount.username === 'studentC' ? 'Wong Chi Keung' : 'Demo User'
          }
        },
        access_token: 'demo_token',
        refresh_token: 'demo_refresh_token'
      };

      onLogin(mockSession);
    } catch (err) {
      setError('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (isSignUp) {
        const { data, error } = await auth.signUp(email, password, {
          username: email.split('@')[0],
          role: 'student' // Default role for sign up
        });

        if (error) {
          setError(error.message);
        } else {
          setError('Please check your email for verification link.');
        }
      } else {
        const { data, error } = await auth.signIn(email, password);

        if (error) {
          setError(error.message);
        } else if (data.user) {
          // Get user profile data
          const { data: profileData } = await userManagement.getUserProfile(data.user.id);
          
          const session = {
            user: {
              ...data.user,
              profile: profileData
            },
            access_token: data.session.access_token,
            refresh_token: data.session.refresh_token
          };

          onLogin(session);
        }
      }
    } catch (err) {
      setError('An error occurred during authentication.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      maxWidth: '400px',
      margin: '0 auto'
    }}>
      <h2 style={{
        textAlign: 'center',
        marginBottom: '20px',
        color: '#4a7c59',
        fontSize: '18px',
        fontWeight: '600'
      }}>
        MyClass 登入系統
      </h2>

      {/* Demo Accounts Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{
          fontSize: '14px',
          color: '#6b7280',
          marginBottom: '10px',
          textAlign: 'center'
        }}>
          測試帳戶 (Demo Accounts)
        </h3>
        
        {/* Admin Account - Highlighted */}
        {adminAccount && (
          <div style={{ marginBottom: '12px' }}>
            <div style={{
              fontSize: '11px',
              color: '#6b7280',
              marginBottom: '6px',
              fontWeight: '500'
            }}>
              👑 管理員帳戶 (Admin Account)
            </div>
            <button
              onClick={() => {
                if (adminAccount) {
                  handleDemoLogin(adminAccount);
                }
              }}
              disabled={loading || !adminAccount}
            style={{
              width: '100%',
              padding: '12px',
              border: '2px solid #dc2626',
              borderRadius: '6px',
              backgroundColor: '#fee2e2',
              color: '#dc2626',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#fecaca';
                e.target.style.borderColor = '#b91c1c';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#fee2e2';
                e.target.style.borderColor = '#dc2626';
              }
            }}
          >
              <span>👑</span>
              <span>Admin (管理員)</span>
              <span style={{ fontSize: '11px', opacity: 0.8 }}>Full Access</span>
            </button>
          </div>
        )}

        {/* Other Demo Accounts */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: '8px'
        }}>
          {/* Other accounts */}
          {demoAccounts.filter(account => account.role !== 'admin').map((account) => (
            <button
              key={account.username}
              onClick={() => handleDemoLogin(account)}
              disabled={loading}
              style={{
                padding: '8px 12px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                backgroundColor: 'white',
                color: '#374151',
                fontSize: '12px',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1,
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = '#f9fafb';
                  e.target.style.borderColor = '#d1d5db';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = '#e5e7eb';
                }
              }}
            >
              <div style={{ fontWeight: '500' }}>{account.username}</div>
              <div style={{ fontSize: '10px', color: '#6b7280' }}>{account.role}</div>
            </button>
          ))}
          
          {/* Admin button in grid (after Parent button) */}
          <button
            key="admin-grid"
            onClick={() => {
              if (adminAccount) {
                handleDemoLogin(adminAccount);
              }
            }}
            disabled={loading || !adminAccount}
            style={{
              padding: '8px 12px',
              border: '2px solid #dc2626',
              borderRadius: '6px',
              backgroundColor: '#fee2e2',
              color: '#dc2626',
              fontSize: '12px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#fecaca';
                e.target.style.borderColor = '#b91c1c';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#fee2e2';
                e.target.style.borderColor = '#dc2626';
              }
            }}
          >
            <div style={{ fontWeight: '600' }}>👑 admin</div>
            <div style={{ fontSize: '10px', color: '#b91c1c' }}>admin</div>
          </button>
        </div>
      </div>

      <div style={{
        borderTop: '1px solid #e5e7eb',
        paddingTop: '20px'
      }}>
        <h3 style={{
          fontSize: '14px',
          color: '#6b7280',
          marginBottom: '15px',
          textAlign: 'center'
        }}>
          正式登入 (Production Login)
        </h3>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              fontSize: '14px',
              color: '#374151',
              fontWeight: '500'
            }}>
              電郵地址
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '14px',
                outline: 'none'
              }}
              placeholder="your.email@myclass.edu.hk"
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              fontSize: '14px',
              color: '#374151',
              fontWeight: '500'
            }}>
              密碼
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '14px',
                outline: 'none'
              }}
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div style={{
              padding: '10px',
              backgroundColor: '#fee2e2',
              border: '1px solid #fecaca',
              borderRadius: '6px',
              color: '#dc2626',
              fontSize: '14px',
              marginBottom: '15px'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#4a7c59',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#3d6b4a';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#4a7c59';
              }
            }}
          >
            {loading ? '處理中...' : (isSignUp ? '註冊' : '登入')}
          </button>
        </form>

        <div style={{
          textAlign: 'center',
          marginTop: '15px'
        }}>
          <button
            onClick={() => setIsSignUp(!isSignUp)}
            style={{
              background: 'none',
              border: 'none',
              color: '#4a7c59',
              fontSize: '14px',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            {isSignUp ? '已有帳戶？登入' : '沒有帳戶？註冊'}
          </button>
        </div>
      </div>

      <div style={{
        marginTop: '20px',
        padding: '15px',
        backgroundColor: '#f9fafb',
        borderRadius: '6px',
        fontSize: '12px',
        color: '#6b7280',
        textAlign: 'center'
      }}>
        <strong>測試說明：</strong><br />
        • 使用上方測試帳戶可快速體驗系統功能<br />
        • 所有測試帳戶已預設為已驗證狀態<br />
        • 正式環境請使用電郵地址和密碼登入
      </div>
    </div>
  );
};

export default SupabaseAuth;
